import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React, { useMemo } from 'react';
import { IDoorInstallationModel } from '../../../../entities-generated/models/project/door-installation-model';
import { IInstallationSiteModel } from '../../../../entities-generated/models/project/installation-site-model';
import { BwjSidePanel } from '../../../../framework/components/bwj-side-panel';
import { BwjButtonType } from '../../../../framework/components/bwj-button';
import { CartInstallationSiteListing } from '../cart-install-site-listing';
import { ProjectService } from '../../../services/project';
import { IProjectConfiguration } from '../../../../entities-generated/models/project/project-configuration';

interface ICartPanelProps {
  showPanel: boolean;
  projectConfig: IProjectConfiguration;
  onCartClose: () => void;
  onDoorSelected: (door: IDoorInstallationModel, site: IInstallationSiteModel) => void;
  onHandleSelected: (door: IDoorInstallationModel, site: IInstallationSiteModel) => void;
  onExcludeInstallation: (door: IDoorInstallationModel, site: IInstallationSiteModel) => void;
  onRestoreInstallation: (door: IDoorInstallationModel, site: IInstallationSiteModel) => void;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    padding: '0 1rem',
  };

  return mergeStyleSets({
    root,
  });
}

export const CartPanel: React.FunctionComponent<ICartPanelProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const { projectConfig } = props;
  const allowExclusion = useMemo(() => ProjectService.getActiveInstallationCount(projectConfig) > 1, [projectConfig]);

  return (
    <BwjSidePanel
      showPanel={props.showPanel}
      title={'My Door Project'}
      footerButtons={[{
        buttonStyle: BwjButtonType.PrimaryStandard,
        text: 'Close',
        onClick: props.onCartClose,
      }]}
      onDismiss={props.onCartClose}
      closeButtonAriaLabel={'Close door project summary panel'}
      contentStyle={{ backgroundColor: theme.palette.neutralLight }}
    >
      <div className={cs.root}>
        {projectConfig.installLocations.map(location =>
          <CartInstallationSiteListing
            key={location.name}
            site={location}
            allowExclusion={allowExclusion}
            onExclude={props.onExcludeInstallation}
            onInclude={props.onRestoreInstallation}
            onDoorSelected={props.onDoorSelected}
            onHandleSelected={props.onHandleSelected}
          />
        )}
      </div>
    </BwjSidePanel>
  );
};
